import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "form-row" }
const _hoisted_2 = ["placeholder", "aria-describedby", "aria-required", "aria-invalid", "id", "autocomplete"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_VueMultiselect = _resolveComponent("VueMultiselect")!
  const _component_ValidatedInput = _resolveComponent("ValidatedInput")!
  const _component_DomesticAddress = _resolveComponent("DomesticAddress")!
  const _component_CanadaAddress = _resolveComponent("CanadaAddress")!
  const _component_InternationalAddress = _resolveComponent("InternationalAddress")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["address-container", { 'fields-compact': _ctx.fieldStyle == _ctx.FieldStyle.Compact }])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_ValidatedInput, {
        id: _ctx.id,
        value: _ctx.address.countryString,
        label: "Country",
        accessibleLabel: _ctx.countryPlaceholder,
        name: _ctx.name + '.Address.CountryString',
        class: "rd-w-full",
        isRequired: _ctx.required,
        maxLength: 50
      }, {
        input: _withCtx((inputProps) => [
          _createVNode(_component_VueMultiselect, {
            id: _ctx.id + '_' + _ctx.name + '.Address.CountryString',
            label: "text",
            "track-by": "value",
            "select-label": "",
            "selected-label": "",
            "deselect-label": "",
            class: "multiselect-element",
            placeholder: _ctx.countryPlaceholder,
            modelValue: _ctx.selectedCountry,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedCountry) = $event)),
            "aria-describedby": inputProps.describedBy,
            "aria-required": inputProps.required,
            "aria-invalid": inputProps.isInvalid,
            options: _ctx.countries,
            autocomplete: _ctx.isShipping ? 'shipping country' : 'billing country'
          }, null, 8, ["id", "placeholder", "modelValue", "aria-describedby", "aria-required", "aria-invalid", "options", "autocomplete"])
        ]),
        _: 1
      }, 8, ["id", "value", "accessibleLabel", "name", "isRequired"])
    ]),
    (_ctx.selectedCountry?.value === 'US')
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass(["form-row", [{ 'rd-mt-4': (_ctx.fieldStyle != _ctx.FieldStyle.Compact && !_ctx.isModalDisplay) }, { 'rd-mt-2.5': (_ctx.fieldStyle != _ctx.FieldStyle.Compact && _ctx.isModalDisplay) }]])
        }, [
          _createVNode(_component_ValidatedInput, {
            id: _ctx.id,
            value: _ctx.smartAddress,
            label: _ctx.address1Label,
            accessibleLabel: _ctx.address1Placeholder,
            class: "rd-w-full",
            name: _ctx.name + '.Address.Address1',
            isRequired: _ctx.required,
            maxLength: 75
          }, {
            input: _withCtx((inputProps) => [
              (_ctx.showAddressSelect)
                ? (_openBlock(), _createBlock(_component_VueMultiselect, {
                    key: 0,
                    ref: "multiselect",
                    id: _ctx.id + '_' + _ctx.name + '.Address.Address1',
                    placeholder: _ctx.address1Placeholder,
                    "track-by": "street",
                    "select-label": "",
                    "selected-label": "",
                    "deselect-label": "",
                    class: "multiselect-element",
                    modelValue: _ctx.smartAddress,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.smartAddress) = $event)),
                    "aria-describedby": inputProps.describedBy,
                    "aria-required": inputProps.required,
                    "aria-invalid": inputProps.isInvalid,
                    options: _ctx.streets,
                    "internal-search": false,
                    onSearchChange: _ctx.findAddress,
                    onSelect: _ctx.selectAddress,
                    "custom-label": _ctx.customLabel,
                    showNoOptions: true,
                    showNoResults: true,
                    autocomplete: _ctx.isShipping ? 'shipping address-line1' : 'billing address-line1'
                  }, {
                    singleLabel: _withCtx((props) => [
                      _createTextVNode(_toDisplayString(props.option.street), 1)
                    ]),
                    noOptions: _withCtx(() => _cache[4] || (_cache[4] = [
                      _createElementVNode("span", { class: "rd-font-medium" }, "No results found.", -1)
                    ])),
                    noResult: _withCtx(() => [
                      _createElementVNode("button", {
                        type: "button",
                        class: "address-no-results",
                        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.closeAddressSearch()))
                      }, " No results found. Click here to enter your address manually. ")
                    ]),
                    _: 2
                  }, 1032, ["id", "placeholder", "modelValue", "aria-describedby", "aria-required", "aria-invalid", "options", "onSearchChange", "onSelect", "custom-label", "autocomplete"]))
                : _withDirectives((_openBlock(), _createElementBlock("input", {
                    key: 1,
                    type: "text",
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.address.address1) = $event)),
                    placeholder: _ctx.address1Placeholder,
                    "aria-describedby": inputProps.describedBy,
                    "aria-required": inputProps.required,
                    "aria-invalid": inputProps.isInvalid,
                    id: _ctx.id + '_' + _ctx.name + '.Address.Address1',
                    autocomplete: _ctx.isShipping ? 'shipping address-line1' : 'billing address-line1'
                  }, null, 8, _hoisted_2)), [
                    [_vModelText, _ctx.address.address1]
                  ])
            ]),
            _: 1
          }, 8, ["id", "value", "label", "accessibleLabel", "name", "isRequired"])
        ], 2))
      : _createCommentVNode("", true),
    (_ctx.selectedCountry?.value === 'US')
      ? (_openBlock(), _createBlock(_component_DomesticAddress, {
          key: 1,
          id: _ctx.id,
          name: _ctx.name,
          address: _ctx.address,
          showAddress2: _ctx.showAddress2,
          states: _ctx.states,
          required: _ctx.required,
          address2Label: _ctx.address2Label,
          address2Placeholder: _ctx.address2Placeholder,
          cityLabel: _ctx.cityLabel,
          cityPlaceholder: _ctx.cityPlaceholder,
          stateLabel: _ctx.stateLabel,
          statePlaceholder: _ctx.statePlaceholder,
          postalLabel: _ctx.postalLabel,
          postalPlaceholder: _ctx.postalPlaceholder,
          onUpdateAddress: _ctx.updateAddress,
          "is-shipping": _ctx.isShipping
        }, null, 8, ["id", "name", "address", "showAddress2", "states", "required", "address2Label", "address2Placeholder", "cityLabel", "cityPlaceholder", "stateLabel", "statePlaceholder", "postalLabel", "postalPlaceholder", "onUpdateAddress", "is-shipping"]))
      : _createCommentVNode("", true),
    (_ctx.selectedCountry?.value === 'CA')
      ? (_openBlock(), _createBlock(_component_CanadaAddress, {
          key: 2,
          id: _ctx.id,
          name: _ctx.name,
          address: _ctx.address,
          showAddress2: _ctx.showAddress2,
          states: _ctx.states,
          required: _ctx.required,
          address1Label: _ctx.address1Label,
          address1Placeholder: _ctx.address1Placeholder,
          address2Label: _ctx.address2Label,
          address2Placeholder: _ctx.address2Placeholder,
          cityLabel: _ctx.cityLabel,
          cityPlaceholder: _ctx.cityPlaceholder,
          stateLabel: _ctx.stateLabel,
          statePlaceholder: _ctx.statePlaceholder,
          postalLabel: _ctx.postalLabel,
          postalPlaceholder: _ctx.postalPlaceholder,
          onUpdateAddress: _ctx.updateAddress,
          "is-shipping": _ctx.isShipping
        }, null, 8, ["id", "name", "address", "showAddress2", "states", "required", "address1Label", "address1Placeholder", "address2Label", "address2Placeholder", "cityLabel", "cityPlaceholder", "stateLabel", "statePlaceholder", "postalLabel", "postalPlaceholder", "onUpdateAddress", "is-shipping"]))
      : _createCommentVNode("", true),
    (_ctx.selectedCountry?.value !== 'CA' && _ctx.selectedCountry?.value !== 'US')
      ? (_openBlock(), _createBlock(_component_InternationalAddress, {
          key: 3,
          id: _ctx.id,
          name: _ctx.name,
          address: _ctx.address,
          showAddress2: _ctx.showAddress2,
          required: _ctx.required,
          address1Label: _ctx.address1Label,
          address1Placeholder: _ctx.address1Placeholder,
          address2Label: _ctx.address2Label,
          address2Placeholder: _ctx.address2Placeholder,
          cityLabel: _ctx.cityLabel,
          cityPlaceholder: _ctx.cityPlaceholder,
          postalLabel: _ctx.postalLabel,
          postalPlaceholder: _ctx.postalPlaceholder,
          onUpdateAddress: _ctx.updateAddress,
          "is-shipping": _ctx.isShipping
        }, null, 8, ["id", "name", "address", "showAddress2", "required", "address1Label", "address1Placeholder", "address2Label", "address2Placeholder", "cityLabel", "cityPlaceholder", "postalLabel", "postalPlaceholder", "onUpdateAddress", "is-shipping"]))
      : _createCommentVNode("", true)
  ], 2))
}